import { IConfigModule } from 'build/types/configs'

const config: IConfigModule = {
  version: '2.0.0',
  allowReferral: true,
  changeIdQr: false,
  filterPrizes: true,
  buttonsStart: ['signIn', 'signUp', 'whatsapp', 'google',],
  positiveLogoUrls: [
    '/terms-and-conditions',
    '/profile',
    '/help',
    '/trivias',
    '/congrats',
    '/ranking/suscribe',
    '/ranking/suscribe/confirm',
    '/end',
    '/trivia/:id',
    '/error/:errorid'
  ],
  usePointsHome: true,
  useSecondBackground: [],
  imageStart: 'backgroundImage',
  welcome: 'ImgBackground',
  legalAgeDate: true,
  routesLinks: [
    {
      path: '/album/redirect/Ticket/upload',
      text: 'SUBIR TICKETS'
    },
    {
      path: '/prizes',
      text: 'CANJEAR PREMIOS'
    },
    {
      path: '/profile/movements',
      text: 'VER MIS PUNTOS'
    },
    {
      path: '/profile',
      text: 'Mi información',
      small: true
    },
    {
      path: '/help',
      text: '¿Tienes alguna duda?',
      small: true
    },
    {
      path: '/terms-and-conditions',
      text: 'Ver términos y condiciones',
      small: true
    },
    {
      path: '/privacy-politics',
      text: 'Ver aviso de privacidad',
      small: true
    }
  ],
  routesHome: ['AmstelID'],
  routesProfile: ['information', 'address', 'phone', 'identificacion', 'history'],
  tracking: true,
  privacyPolitics: 'MX',
  cookies: 'MX',
  trivia: {
    showIntroduction: false,
    interestsRequired: false
  },
  notAvailableFields: ['instagram', 'consumptionCenter', 'nickName', 'sign'],
  notShowFields: ['instagram'],
  usePoints: false,
  profile: {
    notShowButtonInformation: true,
    showButtonPoints: true
  },
  album: {
    loaderPulse: true,
    Ticket: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true,
        howTakePhoto: true
      }
    }
  },
  loaderPulse: true,
  captureBtnBgTransparent: true,
  prizes: {
    description: true,
    filterDots: true
  }
}

export default config
